<ng-container *ngIf="!readonly">
    <label *ngIf="label_block && label" class="m-0 html-label d-block" [ngClass]="{'req':required}"
        [innerHtml]="label|HTMLFormatter" [title]="label | HTMLFormatter : 1"></label>
    <mat-label *ngIf="!label_block && label" class="d-block" [ngClass]="{'req': required}" 
        [title]="label | HTMLFormatter : 1">
        <span [innerHtml]="label | HTMLFormatter"></span>
        <span *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
          <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
            style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
          <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o" [ngClass]="{'pr-3':notes}"
            style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
          <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
            class="fa fa-commenting-o pr-3"></i>
          <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
            class="fa fa-info"></i>
        </span>
    </mat-label>
    <button mat-icon-button [color]="color" *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i"
        (click)="onClick(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
        <mat-icon>
            {{showIcon(i)}}
        </mat-icon>
    </button>
    <mat-error *ngIf="form_control && form_control.touched&& form_control.value == null && required">
        Field is mandatory
    </mat-error>
</ng-container>




<ng-container *ngIf="readonly">
    <label *ngIf="label_block && label" class="m-0 html-label d-block" [ngClass]="{'req':required}"
        [innerHtml]="label|HTMLFormatter" [title]="label | HTMLFormatter : 1"></label>
    <mat-label *ngIf="!label_block && label" class="d-block" [ngClass]="{'req': required}"
        [title]="label | HTMLFormatter : 1">
        <span [innerHtml]="label | HTMLFormatter"></span>
      <span *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
        <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
          style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
        <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o" [ngClass]="{'pr-3':notes}"
          style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
        <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
          class="fa fa-commenting-o pr-3"></i>
        <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
          class="fa fa-info"></i>
      </span>
    </mat-label>
    <button mat-icon-button [color]="color" *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i"
        [matTooltip]="ratingId+1" matTooltipPosition="above">
        <mat-icon>
            {{edit(i)}}
        </mat-icon>
    </button>
</ng-container>